module.exports = __webpack_public_path__ + "static/img/beijing.ebcf45a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/font/beijing.png
// module id = 7EzL
// module chunks = 1